export default "__VITE_ASSET__CYl6PhU0__"